import React, {useEffect, useState,useContext}from 'react';
import { DefaultButton, Modal, IconButton, PrimaryButton, DatePicker, defaultDatePickerStrings, TextField, ChoiceGroup } from '@fluentui/react';
import { Dropdown } from '@fluentui/react';
import "../Styles/EditPatientCss.css";
import { getPatientDetailsAPI } from "../../../../service/StudyListService";
import { useTranslation } from "react-i18next";
import "../../../../index.css";
import loaderContext from '../../../../context/loader/LoaderContext';
import { t } from "i18next";
import studyReportContext from '../../../../context/studyreport/StudyReportContext';
import { USERTYPES } from '../../../../constants/Constants';
import userContext from '../../../../context/users/UserContext';
import { choiceGroupStyles } from '../../../Report/helper/initialData';
import { getEnv } from '../../../../helpers/EnvHelper';

const EditPatientBody = (props) => {
  const {ref, setLoaderRunning} = useContext(loaderContext);
  const {roles, priorityLabels} = useContext(userContext);
  const {alertSuccessModal, setAlertSuccessModal} = useContext(studyReportContext);
    const [modalityList, setModalityList] = useState([]);
    const studyId = props.studyId;

    const [t] = useTranslation();

    const restrictEditPatientForVDC = !(getEnv("REACT_APP_VDC_PLATFORM") === "true") 
    || roles.includes(USERTYPES.FIRMADMIN)
    || roles.includes(USERTYPES.ADMIN)
    || roles.includes(USERTYPES.SUPERVISOR)
    || roles.includes(USERTYPES.FIRMTECHNICIAN)
    || roles.includes(USERTYPES.FIRMDOCTOR)
    ?false:true;

    // const restrictEditModality = props.reportDoneStatus !== null && props.reportDoneStatus !== undefined ? 
    //   props.reportDoneStatus >= 2 : false;
    const restrictEditModality = (props.reportDoneStatus !== null && props.reportDoneStatus !== undefined) ?
        (props.reportDoneStatus === 2 ) : false;
 

      //using this variable to find out the case is in QC or not. We are disabling all fields except study description
    const isQCStudy = props.reportDoneStatus !== null && props.reportDoneStatus !== undefined ? 
      (props.reportDoneStatus == 3 || props.reportDoneStatus == 4 || props.reportDoneStatus == 5 ):false 

      // On a Reported study (reportDoneStatus === 2), FirmAdmin/Supervisor may edit only the Study Description field
    const restrictToStudyDescriptionOnly = props.reportDoneStatus === 2
     && (roles.includes(USERTYPES.FIRMADMIN) || roles.includes(USERTYPES.SUPERVISOR))
     && !(getEnv("REACT_APP_VDC_PLATFORM") == "true" || getEnv("REACT_APP_BVP_PLATFORM") == "true");

    useEffect(() =>{
        getPatientDetails();
    },[studyId]);

    const getPatientDetails = async() =>{
        try{setLoaderRunning(true);
        ref.current.continuousStart();
        const details = await getPatientDetailsAPI(studyId);
        console.log("details, ", details);
        if(details.data.result === "SUCCESS"){

          props.setPatientDetails(details.data.data.studyEditDto);
          formatModalityList(details.data.data.modalityDtoList);
          var filterObjFields = {
            dob: new Date(details.data.data.studyEditDto.patientBirthdate),
            modality: details.data.data.studyEditDto.modality.id,
            sex: details.data.data.studyEditDto.patientSex,
            studyEmergency :  details.data.data.studyEditDto.studyEmergency
          }
          props.setFilterObj({...props.filterObj, ...filterObjFields});
          setLoaderRunning(false);
          ref.current.complete();
        }else{
          //show alert msg with error message
          setLoaderRunning(false);
          ref.current.complete();
          setAlertSuccessModal(()=>{
            const newItem = {...alertSuccessModal};
            newItem.show = true;
            newItem.heading = "Error";
            newItem.isError = false;
            newItem.isSuccess = false;
            newItem.isWarning = true;
            newItem.description = t("string-literals.failed-message");
            return newItem;
          });
          
        }}catch(e){
          setLoaderRunning(false);
          ref.current.complete();
          setAlertSuccessModal(()=>{
            const newItem = {...alertSuccessModal};
            newItem.show = true;
            newItem.heading = "Error";
            newItem.isError = false;
            newItem.isSuccess = false;
            newItem.isWarning = true;
            newItem.description = t("string-literals.failed-message");
            return newItem;
          });
        }
      }

    const dropDownStyle = {
        dropdownItem: {
          fontSize: "12px",
          lineHeight: "18px",
        },
        dropdownItemSelected: {
          fontSize: "12px",
          lineHeight: "18px",
        },
        dropdownItemsWrapper : {
          maxHeight: "300px"
        }
    };

    function formatModalityList (mdList){
        let list1 = [];
        mdList.forEach((element)=>{
          list1.push({key:element.id,text:element.name})
        })
        console.log("list1",list1);
        setModalityList(list1);
      }
  
      const dateOfBirthFunction = (event) => {
        props.setFilterObj({ ...props.filterObj, dob: event });
      };
  
      const modalityFunction = (event, selected) => {
        var modId = selected.key
        props.setFilterObj({ ...props.filterObj, modality: modId,modalityName: selected.text  });
      };
  
      const setSexFunction = (event, selected) => {
        props.setFilterObj({ ...props.filterObj, sex: selected.key });
      };

      const setStudyEmergency = (event, selected) => {
        console.log('studyEmergency ', selected);
        props.setFilterObj({ ...props.filterObj, studyEmergency: selected.key });
      };

      const getPriorityLabel = (key, fallback) =>
        priorityLabels?.find((p) => p.key === key)?.label || fallback;

      const emergencyOptions = [
        {
          key: 1,
          text: "No",
        },
        {
          key: 2,
          text: getPriorityLabel("EMERGENCY", "Emergency"),
        },
        {
          key: 3,
          text: getPriorityLabel("NON_MEDICAL_EMERGENCY", "Non Medical Emergency"),
        },
      ];

    useEffect(() =>{
      console.log("pateint->>>>>>>>>>>>>>>>", props.values);
    }, [props.values]);


  
    const today = new Date();
  return (
    <div className="edit-patient-modal-container">
      <div className="ms-Grid" dir="ltr">
        <div className="ms-Grid-row">
          <TextField
            className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
            name="patientName"
            placeholder={t("patient.name")}
            onChange={props.handleChange}
            value={props.values.patientName}
            errorMessage={props.errors.patientName}
            label={t("patient.name")}
            readOnly={restrictEditPatientForVDC || isQCStudy || restrictToStudyDescriptionOnly}
            onKeyDown={props.handleEnterKeyPress}
            required
          />
        </div>
        <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
          <TextField
            className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
            value={props.values.patientId}
            name="patientId"
            onChange={props.handleChange}
            placeholder={t("patient.id")}
            errorMessage={props.errors.patientId}
            label={t("patient.id")}
            readOnly={restrictEditPatientForVDC || isQCStudy || restrictToStudyDescriptionOnly}
            onKeyDown={props.handleEnterKeyPress}
            required
          />
          <div></div>
          <Dropdown
            styles={dropDownStyle}
            options={modalityList}
            defaultSelectedKey={props.filterObj.modality}
            onChange={modalityFunction}
            // defaultSelectedKeys={editPatientModality}
            //disabled={(restrictEditPatientForVDC || restrictEditModality) || isQCStudy}
            disabled={(restrictEditPatientForVDC || restrictEditModality)}
            className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
            label={t("patient.mod")}
            required
          />
        </div>
        <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
          <TextField
            className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
            value={props.values.age}
            name="age"
            onChange={props.handleChange}
            placeholder={t("patient.placeholder.age")}
            errorMessage={props.errors.age}
            readOnly={restrictEditPatientForVDC ||restrictToStudyDescriptionOnly }
            onKeyDown={props.handleEnterKeyPress}
            label={t("patient.age")}
          />
          <div></div>
          <Dropdown
            options={[
              { key: "M", text: t("patient.male") },
              { key: "F", text: t("patient.female") },
              { key: "O", text: t("patient.other") },
            ]}
            onChange={setSexFunction}
            defaultSelectedKey={props.filterObj.sex}
            disabled={restrictEditPatientForVDC || restrictToStudyDescriptionOnly}
            className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl6"
            label={t("patient.sex")}
            required
          />
        </div>
        <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
          <DatePicker
            className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
            value={props.filterObj.dob}
            name="dob"
            onSelectDate={dateOfBirthFunction}
            strings={defaultDatePickerStrings}
            placeholder={t("patient.placeholder.dob")}
            maxDate={today}
            label={t("patient.dob")}
            disabled={restrictEditPatientForVDC || isQCStudy || restrictToStudyDescriptionOnly}
            formatDate={(date) => {
              const day = date.getDate().toString().padStart(2, "0");
              const month = (date.getMonth() + 1).toString().padStart(2, "0");
              const year = date.getFullYear();
              return `${day}/${month}/${year}`;
            }}
          />
        </div>
        <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
          <TextField
            className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
            name="studyDescription"
            placeholder={t("patient.placeholder.study-description")}
            value={props.values.studyDescription}
            onChange={props.handleChange}
            readOnly={restrictEditPatientForVDC}
            errorMessage={props.errors.studyDescription}
            onKeyDown={props.handleEnterKeyPress}
            label={t("patient.study-description")}
          />
        </div>
        <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
          <TextField
            className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
            name="referringPhysician"
            placeholder={t("patient.placeholder.referring-physician")}
            value={props.values.referringPhysician}
            onChange={props.handleChange}
            readOnly={restrictEditPatientForVDC || isQCStudy|| restrictToStudyDescriptionOnly}
            errorMessage={props.errors.referringPhysician}
            onKeyDown={props.handleEnterKeyPress}
            label={t("patient.referring-physician")}
          />
        </div>
        {/* {props.filterObj.studyEmergency != null && (roles[0] === USERTYPES.FIRMTECHNICIAN || roles[0] === USERTYPES.FIRMDOCTOR) &&
           <div className="ms-Grid-row single-line-form-field" style={{flexDirection : "column", alignItems : "flex-start"}}>
           <div className="ms-Grid-row ms-sm12 ms-lg4 ms-xl6" style={{marginLeft : "10px", marginTop : "10px"}}>
             <p style={{fontWeight : "600"}}>{"Emergency"}</p>
           </div>
           <div className="ms-Grid-row ms-sm12 ms-md8 ms-lg4 ms-xl12" style={{marginLeft : "10px"}}>
             <ChoiceGroup
               defaultSelectedKey={
                props.filterObj.studyEmergency
               }
              // label="Emergency"
               options={emergencyOptions}
               onChange={setStudyEmergency}
               value={props.filterObj.studyEmergency}
               styles={choiceGroupStyles}
             />
           </div>
         </div>
        } */}
       
      {props.reportedModalityError && (
        <div className="ms-Grid-row" style={{ marginTop: "10px" }}>
          <div className="ms-Grid-col ms-sm12" style={{ color: "rgb(230, 18, 28)", fontSize: "12px", fontWeight: "bold" }}>
            {props.reportedModalityError}
          </div>
        </div>
      )}
      </div>
    </div>
  );
}

export default EditPatientBody